import React, { useMemo } from 'react';
import Barcode from 'react-barcode';
import { Popover } from 'antd';

import { ReactComponent as ScannerIcon } from 'src/assets/icons/scanner-gun.svg';

import style from './EanIndicator.module.scss';

const EanIndicator = ({ ean }) => {
  if (!ean) {
    return null;
  }

  const text = useMemo(
    () => (
      <div className={style.wrapper}>
        <p>Ten produkt posiada dodany kod EAN.</p>
        <Barcode
          value={ean}
          height={40}
        />
      </div>
    ),
    [ean]
  );

  return (
    <Popover
      placement={'bottom'}
      content={text}
    >
      <ScannerIcon className={style.icon} />
    </Popover>
  );
};

export default EanIndicator;
